import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { parseWidgetData } from "./parser"
import { updateProductMetaData } from "@containers/App/reducer.js"

export const initialState = {
    bottomSheets: {},
    widgets: [],
    isFetching: false,
    isFetched: false,
    error: false,
    loadingData: null,
    offerType: null,
}

export const offerDetailPageSlice = createSlice({
    name: "offerDetailPage",
    initialState: initialState,
    reducers: {
        setLoadingData: (state, action) => {
            state.loadingData = action.payload
        },
        setDefaultData: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(fetchData.pending, (state) => {
            state.isFetching = true
            state.isFetched = false
            state.error = false
        })
        builder.addCase(fetchData.fulfilled, (state, action) => {
            state.widgets = action.payload.widgets
            state.onPageLoadGA = action.payload.onPageLoadGA
            state.pageScrollGA = action.payload.pageScrollGA
            state.pageTitle = action.payload.pageTitle
            state.bannerImage = action.payload.bannerImage
            state.blurBanner = action.payload.blurBanner
            state.isOfferLocked = action.payload.isOfferLocked
            state.offerType = action.payload.offerType
            state.isFetching = false
            state.isFetched = true
            state.loadingData = null
        })
        builder.addCase(fetchData.rejected, (state, action) => {
            state.error = action.payload.error
            state.isFetching = false
            state.isFetched = false
            state.loadingData = null
        })
    },
})

export const fetchData = createAsyncThunk(
    "offerDetailPage/fetchData",
    async ({ params }, { extra, dispatch, getState, rejectWithValue }) => {
        const { api } = extra
        const onServer = typeof window === "undefined"
        const state = getState()
        const { loggedIn } = state.shellReducer
        const loggedOutError = {
            is_success: false,
            status_code: 400,
            error: {
                message: "Invalid request",
                errors: [
                    {
                        message: "Invalid request",
                    },
                ],
            },
            meta: {
                redirect_status_code: 302,
                redirect_url: "/subscription-plan/subscriptions",
                preserve_query_params: true,
            },
        }
        if (!loggedIn) {
            if (!onServer) window.location.replace(loggedOutError.meta.redirect_url)
            return rejectWithValue(loggedOutError)
        }
        const apiUrl = `/api/v4/partnerships/brand_offer`

        try {
            const response = await api.get(apiUrl, { params })
            if (!onServer && response?.data?.page_properties) {
                const { slug } = response.data.page_properties
                if (slug) {
                    window.location.href = slug
                }
            }
            const parsedData = parseWidgetData(response?.data)
            dispatch(
                updateProductMetaData({
                    title: response.data?.meta_data?.title,
                    description: response.data?.meta_data?.description,
                })
            )
            return Promise.resolve(parsedData)
        } catch (err) {
            const responseError = err.status_code == 400 ? loggedOutError : err
            return rejectWithValue(responseError)
        }
    }
)

export const unlockOffer = createAsyncThunk(
    "offerDetailPage/unlockOffer",
    async ({ params, type }, { extra, dispatch, rejectWithValue }) => {
        dispatch(setLoadingData({ flag: true, type }))

        const { api } = extra

        try {
            await api.put("/api/v4/unlock_offer", params)
            dispatch(fetchData({ params }))
            return Promise.resolve()
        } catch (err) {
            dispatch(setLoadingData({ flag: false, type }))
            return rejectWithValue(err)
        }
    }
)

export const offerDetailPageReducer = offerDetailPageSlice.reducer

export const { setLoadingData, setDefaultData } = offerDetailPageSlice.actions
